/* eslint-disable import/no-named-as-default */

import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
